import { ToneAndVoiceSliders } from "@redotech/redo-merchant-marketing-app/common/ai-tone-and-voice/tone-and-voice-sliders";
import { Flex } from "@redotech/redo-web/flex";
import { AnimatedSkeletonBlock } from "@redotech/redo-web/skeleton";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { ScrollableStepLayout } from "./scrollable-step-layout";
import {
  getStaggeredContentRevealDelayMs,
  StepMotionItem,
} from "./step-motion";
import type { ConciergeToneStepProps } from "./types";

export const ToneVoiceStep = memo(function ToneVoiceStep({
  animateItems = true,
  stepNumber,
  toneInitPending,
  toneSettings,
  setToneSettings,
}: ConciergeToneStepProps) {
  const title = "Make Commerce Agent sound like your brand";

  return (
    <ScrollableStepLayout
      animateItems={animateItems}
      stepNumber={stepNumber}
      subtitle={
        <>
          We&apos;ve drafted a starting voice for Commerce Agent based on an
          analysis of your store. Adjust the sliders now, and you can fine-tune
          the details later.
        </>
      }
      title={title}
    >
      {toneInitPending ? (
        <StepMotionItem
          animateItems={animateItems}
          delayMs={getStaggeredContentRevealDelayMs(title, 0)}
        >
          <AnimatedSkeletonBlock height="320px" width="100%" />
        </StepMotionItem>
      ) : (
        <Flex dir="column" gap="3xl">
          <StepMotionItem
            animateItems={animateItems}
            delayMs={getStaggeredContentRevealDelayMs(title, 0)}
          >
            <ToneAndVoiceSliders
              onChange={setToneSettings}
              settings={toneSettings}
            />
          </StepMotionItem>
          <StepMotionItem
            animateItems={animateItems}
            delayMs={getStaggeredContentRevealDelayMs(title, 1)}
          >
            <Text fontSize="sm" textColor="tertiary">
              You can add specific voice instructions later,
              <br />
              including special guidance for different customer moments.
            </Text>
          </StepMotionItem>
        </Flex>
      )}
    </ScrollableStepLayout>
  );
});
